import { useState } from 'react'
import FragranceImage from '../collection/FragranceImage'
import { anniversaryLead, anniversarySentence, readDismissedDay, writeDismissedDay } from '../../lib/memoryAnniversary'

// "On this day" (IDEA-MEMORY-ANNIVERSARY-001): one memory from today's date in an
// earlier year, with the two actions that turn it into a wear. Dismiss hides the
// card for the rest of the day on this device.
export default function MemoryAnniversaryCard({ items, today, onWear, onOpen }) {
  const [dismissedDay, setDismissedDay] = useState(() => readDismissedDay())
  const [index, setIndex] = useState(0)
  if (!items?.length || dismissedDay === today) return null
  const item = items[Math.min(index, items.length - 1)]
  const name = item.fragrance?.name || 'this bottle'

  const dismiss = () => {
    writeDismissedDay(today)
    setDismissedDay(today)
  }

  return (
    <section aria-label="On this day" data-memory-anniversary className="rounded-xl border border-gold/30 bg-charcoal-800 p-3">
      <div className="flex items-start justify-between gap-2">
        <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-gold/80">On this day</p>
        <button type="button" onClick={dismiss} aria-label="Hide for today" className="-m-2 flex min-h-11 min-w-11 items-center justify-center rounded-lg text-cream/40 hover:text-cream/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/70">×</button>
      </div>
      <button type="button" onClick={() => onOpen(item.fragrance)} aria-label={`Open details for ${name}`} className="group -mt-1 flex w-full min-w-0 items-center gap-3 rounded-lg p-1 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/70">
        <span className="w-14 shrink-0"><FragranceImage fragrance={item.fragrance} /></span>
        <span className="min-w-0 flex-1">
          <span className="block text-xs text-cream/55">{anniversaryLead(item.yearsAgo)}</span>
          <span className="block break-words text-sm font-semibold leading-snug text-cream group-hover:text-gold">{anniversarySentence(item)}</span>
          {item.note && <span className="mt-0.5 line-clamp-2 block text-xs italic text-cream/50">“{item.note}”</span>}
        </span>
      </button>
      <div className="mt-2 flex items-center justify-between gap-2">
        {items.length > 1 ? (
          <button type="button" onClick={() => setIndex(current => (current + 1) % items.length)} className="min-h-11 rounded-lg px-1 text-xs text-cream/55 hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/70">
            {index % items.length + 1} of {items.length} · Next memory
          </button>
        ) : <span />}
        <button type="button" onClick={() => onWear(item.fragrance)} className="inline-flex min-h-11 items-center justify-center rounded-lg border border-gold/70 px-3 text-xs font-semibold text-gold transition-colors hover:bg-gold/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold">
          Wear it today
        </button>
      </div>
    </section>
  )
}
